import {Ref} from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './TransactionDetails.css';
import {TEticketData} from '../../../../redux/eTicket/eTicket.type';
import TransactionDealSummary from '../TransactionDealSummary/TransactionDealSummary';
import TransactionInfoBlock from '../TransactionInfoBlock/TransactionInfoBlock';
import TransactionAddressBlock from '../TransactionAddressBlock/TransactionAddressBlock';
import TransactionPayment from '../TransactionPayment/TransactionPayment';
import {useIsSubscription} from '../../hooks/useIsSubscription';
import {getSubscriptionVenues} from '../../MemberTicket/memberTicket.utils';

interface TransactionDetailsProps {
    data: TEticketData;
    scrollRef: Ref<HTMLDivElement>;
}

function TransactionDetails({data, scrollRef}: TransactionDetailsProps) {
    const {t} = useTranslation('eTicket');
    const isSubscription = useIsSubscription();
    const {event, transaction, producer, order} = data;
    const ordererName = [order?.nameFirst, order?.nameLast].filter(Boolean).join(' ');
    // A subscription shows a venue only when every series in the order shares one, as the navigate action does
    const subscriptionVenues = isSubscription ? getSubscriptionVenues(data.tickets) : [];
    const venue = isSubscription ? (subscriptionVenues.length === 1 ? subscriptionVenues[0] : undefined) : event;
    const location = venue?.location;
    const address = venue?.address;
    const hasPayment = !!(order?.payMethod || order?.created);
    return (
        <css.body ref={scrollRef} data-cy="transaction-details">
            {transaction && <TransactionDealSummary transaction={transaction} />}
            {producer && !producer.hidden && (producer.packageName || producer.phone || producer.email) && (
                <>
                    <css.separator />
                    <TransactionInfoBlock
                        heading={t('producerDetails')}
                        name={producer.packageName}
                        phone={producer.phone}
                        email={producer.email}
                        data-cy="transaction-producer" />
                </>
            )}
            {ordererName && (
                <>
                    <css.separator />
                    <TransactionInfoBlock
                        heading={t('ordererDetails')}
                        name={ordererName}
                        phone={order?.phone}
                        email={order?.email}
                        data-cy="transaction-orderer" />
                </>
            )}
            {(location || address) && (
                <>
                    <css.separator />
                    <TransactionAddressBlock location={location} address={address} />
                </>
            )}
            {hasPayment && order && (
                <>
                    <css.separator />
                    <TransactionPayment order={order} />
                </>
            )}
        </css.body>
    );
}

export default TransactionDetails;
